import { type FulfillmentApi } from '@entities/fulfillment'

/**
 * Подсказка города в списке: название и область одной строкой. Обрезаем, а не переносим — иначе
 * город с длинной областью разъезжается на три строки на узком экране.
 */
export const CityOptionText = ({ option }: { option: FulfillmentApi.ServiceCity }) => (
  <span className="truncate">
    {option.name}
    <span className="text-muted-foreground">, {option.region_name}</span>
  </span>
)
